import { DiscountLine } from "./DiscountLine";
import { NextPaymentLine } from "./NextPaymentLine";
import { TotalDueLine } from "./TotalDueLine";
import { ViewOrderDetailsLine } from "./ViewOrderDetailsLine";

export const ModalPreview = () => (
  <>
    <div className="flex flex-col gap-y-0.5">
      <div className="flex flex-row justify-between">
        <TotalDueLine />
      </div>
      <div className="flex flex-row justify-between">
        <ViewOrderDetailsLine />
        <DiscountLine />
      </div>
    </div>
    <NextPaymentLine />
  </>
);
